import NavigationItem from 'components/NavigationItem';
import styled from 'styled-components';

export const StyledNavigationItem = styled(NavigationItem)`
  padding: 0 16px;
`;
